import { render, staticRenderFns } from "./JobBoardView.vue?vue&type=template&id=00a4b1f9&scoped=true"
import script from "./JobBoardView.vue?vue&type=script&lang=js"
export * from "./JobBoardView.vue?vue&type=script&lang=js"
import style0 from "./JobBoardView.vue?vue&type=style&index=0&id=00a4b1f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a4b1f9",
  null
  
)

export default component.exports